(function () {
  'use strict';

  var routeRoot = window.Shopify && window.Shopify.routes
    ? window.Shopify.routes.root
    : '/';
  var lastCartTrigger = null;

  function drawer() {
    return document.querySelector('[data-ris-cart-drawer-section]');
  }

  function updateHeaderCount() {
    var currentDrawer = drawer();
    if (!currentDrawer) return;
    var count = currentDrawer.getAttribute('data-ris-cart-count') || '0';
    document.querySelectorAll('.ris-cart [data-ris-cart-count]').forEach(function (bubble) {
      bubble.textContent = count;
    });
  }

  function openDrawer(trigger) {
    var currentDrawer = drawer();
    if (!currentDrawer) return;
    lastCartTrigger = trigger || document.activeElement;
    currentDrawer.classList.add('is-open');
    currentDrawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('ris-cart-drawer-open');
    var panel = currentDrawer.querySelector('.ris-cart-drawer__panel');
    if (panel) panel.focus();
  }

  function closeDrawer() {
    var currentDrawer = drawer();
    if (!currentDrawer) return;
    currentDrawer.classList.remove('is-open');
    currentDrawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('ris-cart-drawer-open');
    if (lastCartTrigger && typeof lastCartTrigger.focus === 'function') {
      lastCartTrigger.focus();
    }
  }

  function replaceDrawer(html) {
    if (!html) return false;
    var parsed = new DOMParser().parseFromString(html, 'text/html');
    var nextDrawer = parsed.querySelector('[data-ris-cart-drawer-section]');
    var currentDrawer = drawer();
    if (!nextDrawer || !currentDrawer) return false;
    currentDrawer.replaceWith(nextDrawer);
    updateHeaderCount();
    return true;
  }

  function setAddedMessage(item, requestedQuantity) {
    var message = drawer() && drawer().querySelector('[data-ris-cart-added]');
    if (!message) return;
    var title = item && (item.product_title || item.title);
    var quantity = requestedQuantity || (item && item.quantity) || 1;
    message.textContent = 'Added ' + quantity + ' × ' + (title || 'item') + ' to your cart.';
    message.hidden = false;
  }

  function syncQuantityBreaks(form) {
    if (!form) return;
    var input = form.querySelector('input[name="quantity"]');
    var addButton = form.querySelector('[data-ris-add-to-cart]');
    if (!input) return;
    var quantity = Math.max(1, parseInt(input.value, 10) || 1);
    var selected = null;

    form.querySelectorAll('[data-ris-quantity-break]').forEach(function (button) {
      var tier = parseInt(button.getAttribute('data-ris-quantity-break'), 10) || 1;
      if (tier <= quantity && (!selected || tier > selected.tier)) {
        selected = { button: button, tier: tier };
      }
      button.classList.remove('is-active');
      button.setAttribute('aria-pressed', 'false');
    });

    if (selected) {
      selected.button.classList.add('is-active');
      selected.button.setAttribute('aria-pressed', 'true');
    }

    if (addButton && !addButton.disabled) {
      addButton.textContent = quantity > 1 ? 'Add ' + quantity + ' to Cart' : 'Add to Cart';
    }
  }

  document.addEventListener('click', function (event) {
    var openButton = event.target.closest('[data-ris-cart-open]');
    if (openButton) {
      event.preventDefault();
      openDrawer(openButton);
      return;
    }

    if (event.target.closest('[data-ris-cart-close]')) {
      event.preventDefault();
      closeDrawer();
      return;
    }

    var tierButton = event.target.closest('[data-ris-quantity-break]');
    if (tierButton) {
      var form = tierButton.closest('.ris-product-form');
      var input = form && form.querySelector('input[name="quantity"]');
      if (!input) return;
      input.value = tierButton.getAttribute('data-ris-quantity-break');
      input.dispatchEvent(new Event('input', { bubbles: true }));
    }
  });

  document.addEventListener('input', function (event) {
    if (event.target.matches('.ris-product-form input[name="quantity"]')) {
      syncQuantityBreaks(event.target.closest('.ris-product-form'));
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && drawer() && drawer().classList.contains('is-open')) {
      closeDrawer();
    }
  });

  document.addEventListener('submit', function (event) {
    var form = event.target.closest('.ris-product-form');
    if (!form) return;
    event.preventDefault();

    var addButton = form.querySelector('[data-ris-add-to-cart]');
    var errorBox = form.querySelector('[data-ris-cart-error]');
    var quantityInput = form.querySelector('input[name="quantity"]');
    var requestedQuantity = quantityInput ? Math.max(1, parseInt(quantityInput.value, 10) || 1) : 1;
    var originalButtonText = addButton ? addButton.textContent : '';
    var formData = new FormData(form);

    formData.set('sections', 'ris-cart-drawer');
    formData.set('sections_url', '/cart');

    if (errorBox) {
      errorBox.hidden = true;
      errorBox.textContent = '';
    }
    if (addButton) {
      addButton.disabled = true;
      addButton.textContent = 'Adding…';
    }

    fetch(routeRoot + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: formData
    })
      .then(function (response) {
        return response.json().then(function (data) {
          if (!response.ok) {
            throw new Error(data.description || data.message || 'This item could not be added.');
          }
          return data;
        });
      })
      .then(function (data) {
        if (data.sections && data.sections['ris-cart-drawer']) {
          replaceDrawer(data.sections['ris-cart-drawer']);
        }
        var addedItem = data.items && data.items.length ? data.items[0] : data;
        setAddedMessage(addedItem, requestedQuantity);
        openDrawer(addButton);
      })
      .catch(function (error) {
        if (errorBox) {
          errorBox.textContent = error.message;
          errorBox.hidden = false;
        }
      })
      .finally(function () {
        if (addButton) {
          addButton.disabled = false;
          addButton.textContent = originalButtonText;
        }
        syncQuantityBreaks(form);
      });
  });

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.ris-product-form').forEach(syncQuantityBreaks);
    updateHeaderCount();
  });
})();
